import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Router as ReactRouter, Switch, Route, Redirect } from 'react-router-dom'

import { map } from 'lodash'

import { auth, routing } from '../redux'

import * as containers from '../containers'
import MainLayout from '../containers/MainLayout'
import SplashLayout from '../containers/SplashLayout'

const renderRoute = ({ isPublic, isAuthenticated, component, props }) => {
    if (!containers[component]) {
        throw new Error(`Missing container component: ${component}`)
    }

    if (isPublic && isAuthenticated) {
        return <Redirect to={ routing.routeFor('dashboard') } />
    }

    if (!isPublic && !isAuthenticated) {
        return <Redirect to={ routing.routeFor('login') } />
    }

    const content = React.createElement(containers[component], props)

    return isPublic
        ? <SplashLayout>{ content }</SplashLayout>
        : <MainLayout>{ content }</MainLayout>
}

class Router extends React.Component {
    componentDidMount() {
        const { dispatch } = this.props
        const { history, updateRoute } = routing
        history.listen((route) => dispatch(updateRoute(route)))
        dispatch(updateRoute(history.location))
    }

    render() {
        const { isAuthenticated } = this.props
        return (
            <ReactRouter history={ routing.history }>
                <Switch>
                    { map(routing.ROUTES, ({ path, component, isPublic }, key) => (
                        <Route
                            key={ key }
                            path={ path }
                            render={ (props) => renderRoute({
                                isPublic, isAuthenticated, component, props
                            }) }
                            exact
                        />
                    )) }
                    <Route
                        render={ (props) => {
                            const newProps = { ...props, errorType: 'notFound' }
                            return renderRoute({ component: 'ErrorPage', isAuthenticated, props: newProps })
                        } }
                    />
                </Switch>
            </ReactRouter>
        )
    }
}

function mapStateToProps(state) {
    return {
        isAuthenticated: auth.isAuthenticated(state)
    }
}

Router.propTypes = {
    isAuthenticated : PropTypes.bool.isRequired,
    dispatch        : PropTypes.func.isRequired
}

renderRoute.propTypes = {
    isPublic        : PropTypes.bool.isRequired,
    isAuthenticated : PropTypes.bool.isRequired,
    component       : PropTypes.func.isRequired,
    props           : PropTypes.object
}

export default connect(mapStateToProps)(Router)
